import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import { Form, Button } from 'react-bootstrap';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
  const [user, setUser] = useState({username: '', inout: '', days:'', room: '',guest: '', name: "", email: "", message: "" , });
  


  const {username, inout, days, room, guest, name, email,  message } = user;

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
     setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(user);
    setUser({username:"", inout:"", days:'',room:'',guest:'', name: "", email: "",  message: "" });

     toast.success("✅ Booking Successful!", {
          position: "bottom-right",
          autoClose: 3000,
        });
  };

  return (
    <>
    {/* Hero baneer =========================  */}
    <div className="booking-hero" style={{ backgroundImage: `url('/image/bg3.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', minHeight: '70vh', position: 'relative', }} >
      <div style={{ position: 'absolute', 
        top: 0, left: 0, 
        width: '100%', height: '100%', 
        backgroundColor: 'rgba(0, 0, 0, 0.5)', 
        zIndex: 1, }} >          
        </div>
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row align-items-center justify-content-between flex-wrap">

          {/* Left Text ================= */}
          <div className="col-md-6 text-white" style={{ paddingTop: '50px' }}>
            <h1 className="display-4 fw-bold">The Mountains Are Calling Rest Here</h1>
            <p className="lead mt-3"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <Button variant="primary" className="mt-4">ROOM & SUITES</Button>
          </div>

          {/* Right Form ===================== */}
          <div className="col-md-5 "  >
            <div className=" p-4 rounded shadow form-box  " style={{ margin: '120px 0  50px ', backgroundColor:"#475E6E" }} >
              <h4 className="mb-4 text-center fw-bold">Hotel Booking</h4>

              <Form onSubmit={handleSubmit} >
                <Form.Group className="mb-3"> <Form.Control type="text" name="username" value={username} onChange={handleChange} 
                    placeholder="Your Name" required style={{ height: '50px', fontSize: '16px' }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="text" name="inout" value={inout} onChange={handleChange} placeholder="Check In / Out" 
                      required style={{ height: '50px', fontSize: '16px' }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="date" name="days" value={days} onChange={handleChange} required style={{ height: '50px', fontSize: '16px' }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Select name="room" value={room} onChange={handleChange} required style={{ height: '50px', fontSize: '16px' }} >
                    <option value="">Room</option>
                    <option value="1">1 Room</option>
                    <option value="2">2 Rooms</option>
                    <option value="3">3 Rooms</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Select name="guest" value={guest} onChange={handleChange} required style={{ height: '50px', fontSize: '16px' }} >
                    <option value="">Guest</option>
                    <option value="Adult">Adult</option>
                    <option value="Children">Children</option>
                    <option value="Couple">Couple</option>
                  </Form.Select>
                </Form.Group>
                <Button type="submit" className="w-100 btn-dark">CHECK AVAILABILITY</Button>
              </Form>
              <ToastContainer />
            </div>
          </div>

        </div>
      </div>
    </div>

      
     {/* Form Section 2222222222 ==========================*/}
     
    <div className='p-5 d-flex flex-wrap' style={{backgroundColor:"rgba(0, 0, 0, 0.1)"}}>     
      <div className='col-lg-6 col-md-6 col-sm-12 p-3 text-start '>
        <h5 className='pt-5'>SEND US EMAIL</h5>
        <p className='display-3 pb-3'>Feel free to write</p>
        <form onSubmit={handleSubmit} className='form-container'>
        
            <div>
              <input type="text" name='name' value={name} onChange={handleChange} className='form-control p-3 mb-3'required placeholder='Your Name'/>
              <input type="email" name='email' value={email} onChange={handleChange} className='form-control p-3 mb-3' required placeholder='Email Address'/>
              <input type="text" name='message' value={message} onChange={handleChange} className='form-control p-3 mb-3' placeholder='Message About Us'/>  
               <button type='submit' className='btn btn-primary col-md-6  '>Submit</button>     
          </div>         
       
             
         
 
        </form>
      </div>

          {/* Contact Info Section =========================*/}
          <div className='col-lg-6 col-md-6 col-sm-12 p-3'   >
            <div className='text-start pt-5 '>
            <h4>Need any help?</h4>
            <h1 className='display-3 pb-3'>Get in touch with us</h1>
            <p>Lorem ipsum is simply free text available dolor sit amet consectetur notted adipisicing elit sed do eiusmod tempor incididunt simply dolore magna.</p>
            </div>
          
            <div className="contact-info mt-4">

      {/* Phone */}
      <div className='d-flex align-items-center gap-3 mb-3'>
        <a href="tel:+8801753142800" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faPhone} size="3x" />
          <span className='ps-2'>+880 1753142800</span>
        </a>
      </div>

      {/* Email */}
      <div className='d-flex align-items-center gap-3 mb-3'>
        <a href="mailto:rouf2025s@gmail.com"
            style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faEnvelope} size="3x" />
          <span className='ps-2'>rouf2025s@gmail.com</span>
        </a>
      </div>

      {/* Location */}
      <div className='d-flex align-items-center gap-3 mb-3'>
        <a 
          href="https://surl.li/iipwyp" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: 'black' }} >
          <FontAwesomeIcon icon={faMapMarkerAlt} size="3x" />
          <span className='ps-2'>Boropol, Halisohor, Chattogram.</span>
        </a>
        
      </div>

    </div>

      </div>
    </div>
    </>
  );
};

export default Contact;
